import type { Lot } from '@/types/api';
import { RowActionsDropdown, RowActionsMenuItem } from '@/components/ui/RowActionsDropdown';
import { ArrowLeftRight, ClipboardList, Trash2 } from 'lucide-react';

type LotRowActionsMenuProps = {
  lot: Lot;
  onRegisterEvent: (lot: Lot) => void;
  onRegisterMovement: (lot: Lot) => void;
  onDelete?: (lot: Lot) => void;
  canDelete?: boolean;
};

export function LotRowActionsMenu({
  lot,
  onRegisterEvent,
  onRegisterMovement,
  onDelete,
  canDelete = false,
}: LotRowActionsMenuProps) {
  return (
    <RowActionsDropdown label={`Ações para lote ${lot.name}`}>
      <RowActionsMenuItem
        icon={ClipboardList}
        label="Registrar Evento"
        onClick={() => onRegisterEvent(lot)}
      />
      <RowActionsMenuItem
        icon={ArrowLeftRight}
        label="Registrar Movimentação"
        onClick={() => onRegisterMovement(lot)}
      />

      {canDelete && onDelete && (
        <>
          <div className="my-1 border-t border-manejai-sand/60" />
          <RowActionsMenuItem
            icon={Trash2}
            label="Excluir Lote"
            onClick={() => onDelete(lot)}
            danger
          />
        </>
      )}
    </RowActionsDropdown>
  );
}
